import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, WhatsAppIcon, InputText } from '@aftersale-next/ui';
import ChannelConfirmationContainer from './channel-confirmation-container';
import * as channel from '../../config/constants/channel';
import PhoneMask from '../../masks-and-validators/phone';
import { useChannelMutation } from '../../hooks/use-channel-mutation';
import { useAppMode } from '../../hooks/use-app-mode';
import { useChannelSelection } from '../../hooks/use-channel-selection';
import { useUserInfo } from '../../hooks/use-user-info';

function useWhatsappConfirmation() {
  var _useAppMode = useAppMode(),
      _useAppMode2 = _slicedToArray(_useAppMode, 2),
      setMode = _useAppMode2[1];

  var _useChannelSelection = useChannelSelection(),
      _useChannelSelection2 = _slicedToArray(_useChannelSelection, 2),
      setSelected = _useChannelSelection2[1];

  var mutation = useChannelMutation({
    onSuccess: function onSuccess() {
      setMode('tracking');
      setSelected('');
    }
  });
  return mutation;
}

export default function WhatsappConfirmation() {
  var customerPhone = useUserInfo('whatsapp');

  var _useState = useState(''),
      phone = _useState[0],
      setPhone = _useState[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var mutation = useWhatsappConfirmation();
  var error = !PhoneMask.validate(phone);

  var handlePhoneChange = function handlePhoneChange(newPhone) {
    return setPhone(newPhone);
  };

  var handleConfirm = function handleConfirm() {
    if (phone && PhoneMask.validate(phone)) {
      mutation.mutate({
        channel: channel.WHATSAPP,
        data: {
          phone: "55".concat(phone)
        }
      });
    }
  };

  useEffect(function () {
    setPhone(customerPhone);
  }, [customerPhone]);
  return /*#__PURE__*/_jsx(ChannelConfirmationContainer, {
    name: "whatsapp",
    isDisabled: mutation.isLoading || error,
    isLoading: mutation.isLoading,
    handleConfirm: handleConfirm,
    label: t('WHATSAPP'),
    icon: /*#__PURE__*/_jsx(WhatsAppIcon, {
      background: colors.buttonForeground
    }),
    iconBgColor: colors.whatsapp,
    children: /*#__PURE__*/_jsx(InputText, {
      id: "phone-input",
      name: "phone-input",
      label: t('CELL_PHONE_WITH_DDD'),
      placeholder: t('CELL_PHONE_WITH_DDD_PLACEHOLDER'),
      value: phone,
      onChange: handlePhoneChange,
      maxLength: 11,
      format: PhoneMask.maskWithoutCountry,
      unformat: PhoneMask.unmask,
      error: error
    })
  });
}